import { useToast } from "@commonlibs";
import { UseMutationResult, useMutation, useQueryClient } from "react-query";
import useTranslate from "ui/locale/hooks/useTranslate";
import { Queries } from "ui/query/queries";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { pointsApi } from "../api/pointsApi";

export interface UpdateCaducityParams {
    caducityDays: number;
}

export default function useUpdateCaducity({
    onSuccess,
    ...options
}: UseCustomMutationOptions<void, unknown, UpdateCaducityParams> = {}): UseMutationResult<void, unknown, UpdateCaducityParams> {
    const { showToast } = useToast();
    const translate = useTranslate();
    const queryClient = useQueryClient();

    return useMutation(
        async ({ caducityDays }: UpdateCaducityParams) => {
            await pointsApi.updateCaducity({ caducityDays });
        },
        {
            onSuccess: (data, variables, context) => {
                showToast(translate("caducityDaysUpdatedSuccessfully"), { type: "success" });
                queryClient.invalidateQueries([Queries.POINT_FIND_BY]);
                onSuccess?.(data, variables, context);
            },
            ...options,
        },
    );
}
